export default __webpack_public_path__ + "static/media/lock.1bc6462d.svg";